import * as cryptoRandomString from 'crypto-random-string';
import { useTranslation } from 'react-i18next';
import { SetValueFunction } from '../interfaces/IDynamicFormRow';

interface IDiscountCodeGenerator {
    className: string;
    setValue: SetValueFunction;
    keyName: string;
    triggerValidation: (value: string | string[]) => Promise<boolean>;
}

export function DiscountCodeGenerator({ className, setValue, keyName, triggerValidation }: IDiscountCodeGenerator) {
    const { t } = useTranslation();

    function onClick() {
        const code: string = cryptoRandomString({
            length: 12,
            type: 'alphanumeric',
        });
        setValue(keyName, code, { shouldDirty: true });
        triggerValidation(keyName);
    }
    return (
        <div className={className}>
            <div onClick={onClick}>
                <p>{t('discounts.discountsContainer.autoGenerateCode')}</p>
            </div>
        </div>
    );
}
